import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS } from '../types/auth';
import { SET_NAVBAR_INFO, SET_NAVBAR_INFO_LOADING } from '../types/navbarInfo';
import { VERIFY_OTP_PAYMENT_SUCCESS } from '../types/onBoarding';

export type NavbarInfoType = {
    rmName: string;
    businessDate: string;
    company: string;
    isNavbarInfoLoading: boolean;
    environment: string;
    userRole: string;
};

const initState: Partial<NavbarInfoType> = {
    rmName: "",
    businessDate: "",
    company: "",
    isNavbarInfoLoading: false,
    environment: "",
    userRole: ""
};
export default function navbarInfoReducer(state = initState, action: AnyAction): Partial<NavbarInfoType> {
    switch (action.type) {
        case VERIFY_OTP_PAYMENT_SUCCESS: {
            return {
                ...state,
                company: action?.body?.company ?? "",
            }
        }
        case SET_NAVBAR_INFO: {
            return {
                ...state,
                rmName: action.rmName,
                businessDate: action.businessDate,
                company: action.company,
                environment: action.environment,
                userRole: action.userRole
            };
        }
        case SET_NAVBAR_INFO_LOADING: {
            return {
                ...state,
                isNavbarInfoLoading: action.isNavbarInfoLoading
            }
        }
        case LOGOUT_SUCCESS: {
            return initState
        }
        default:
            return state;
    }
}